import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MileageDataService {
  private mileageData: {
    vin: string;
    mileage: string;
    vehicle: string;
    policyNumber: string;
  } = {
    vin: "",
    mileage: "",
    vehicle: "",
    policyNumber: ""
  }
  public details = new BehaviorSubject<any>(this.mileageData);
  $mileageData = this.details.asObservable();
  public showConfimationBox = new BehaviorSubject<any>(false);

  updatemileage(mileageData: {
    vin: string;
    mileage: string;
    vehicle: string;
    policyNumber: string;
  }) {
    this.details.next(mileageData);
  }

  clear() {
    this.details.next('');
  }
}
